import { Injectable } from '@angular/core';
import { ClienteService } from '../services/cliente.service';
import { Cliente } from '../persistences/cliente';
import { ClienteSingletonService } from '../singletons/cliente-singleton.service';
import { JwtService } from '../jwt.service';
import { SnackbarManager } from './snackbar-manager';
import { ClienteFilial } from '../persistences/cliente-filial';

@Injectable({
  providedIn: 'root'
})
export class ClienteManager {

  constructor(
    private clienteService: ClienteService,
    private clienteSingleton: ClienteSingletonService,
    private jwtService: JwtService,
    private snackBarManager: SnackbarManager,
  ) { }

  getCliente(): Cliente {
    this.clienteService.getCliente()
      .subscribe(
        (response: Cliente) => {
          this.clienteSingleton.cliente = response;
          this.getClienteFilial(Number.parseInt(localStorage.getItem('filial')));
        },
        (error) => {
          this.jwtService.validarAcessToken(error)
          this.snackBarManager.openSnackBar(error.error, "Ok", 3000);
        }
      );
    return this.clienteSingleton.cliente;
  }

  getClienteFilial(cdFilial: number): ClienteFilial {
    this.clienteService.getClienteFilial(cdFilial)
      .subscribe(
        (response: ClienteFilial) => {
          if (response.imgStr == "") {
            response.imgStr = "assets/images/sem_imagem.png";
          }
          else {
            response.imgStr = "data:image/jpeg;base64," + response.imgStr;

          }
          this.clienteSingleton.clienteFilial = response;
          this, this.gravarClienteNoLocalStorage(this.clienteSingleton);
        },
        (error) => {
          this.jwtService.validarAcessToken(error)
          this.snackBarManager.openSnackBar(error.error, "Ok", 3000);
        }
      );
    return this.clienteSingleton.clienteFilial;
  }

  validarClienteVendedor(): boolean {
    if ((this.clienteSingleton.cliente.cdFuncionario === 0) ||
      (this.clienteSingleton.cliente.cdFuncionario == undefined)) {
      this.snackBarManager.openSnackBar(
        "Cliente não possui um vendedor padrão configurado!",
        'Ok',
        3000
      );
      return false;
    }
    return true;
  }

  gravarClienteNoLocalStorage(clienteSingleton: ClienteSingletonService) {
    localStorage.setItem('cliente', JSON.stringify(clienteSingleton));
  }
}
